var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEtherIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.95,
    width: 40,
    height: 40,
    rx: 5,
    fill: "#F3F6F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30_2305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9971 4L19.7788 4.72902V25.8834L19.9971 26.0975L29.9927 20.2932L19.9971 4Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9975 4L10.002 20.2931L19.9975 26.0976V15.8299V4Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9971 27.9567L19.874 28.1041V35.6397L19.9971 35.9927L29.9986 22.1553L19.9971 27.9567Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.997 35.9928V27.9567L10.0015 22.1553L19.997 35.9928Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9971 26.0971L29.9925 20.2929L19.9971 15.8296V26.0971Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0015 20.2933L19.9969 26.0977V15.8301L10.0015 20.2933Z",
    fill: "#393939"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_2305"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 32,
    fill: "white",
    transform: "translate(10 4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtherIcon);
export default __webpack_public_path__ + "static/media/EtherIcon.e38c636eac131bc8affa7c794bbc4e23.svg";
export { ForwardRef as ReactComponent };